import * as Base64 from 'js-base64';
const decode = (Base64 as any).decode || Base64;
import { Site, SLD } from '@patsnap-utils/biz';
import type { CredentialResponse } from '../types/accounts';
import {
    getParamsUrl,
    postLoginSocialIndividual,
    postLoginSocialIndividualPassword,
} from '../utils/sign-up';
import { Toast } from 'patsnap-biz';
import { openMessageBox } from '../components/message-box/messageBox';
import { useTenant } from './use-tenant';
import { useI18n } from 'vue-i18n';
import _ from 'lodash';
import { useChannels } from './use-channels';
import { ERROR_CODE } from '../types/error-codes';

/**
 * 验证密码，邮箱账号已经存在时
 * @param data
 * @returns
 */
async function checkPassword(data: { email: string }) {
    const password = await openMessageBox({
        email: data.email,
    });
    return password;
}

/**
 * 刷新页面, 用于登录成功后
 */
function refreshPage() {
    window.location.reload();
}

/**
 * 提交密码验证
 * @param data
 */
async function submitPassword(data: { password: string; credential: string }) {
    const token = await postLoginSocialIndividualPassword(data);
    return token;
}

function getErrorCode(error: unknown) {
    const code =
    _.get(error, 'response.data.errcode') ||
    _.get(error, 'response.data.numeric_error_code');
    return code as unknown as number;
}

export function useGoogleLogin() {
    const { t, te } = useI18n();
    const { channels } = useChannels()

    function alertErrorByCode(data: { code: string | number; email: string }) {
        const { code } = data;
        const defaultCode = 'unknown';
        const codeKey = te(`us.google_login.${code}`) ? code : defaultCode
        const message = t(`us.google_login.error_code.${codeKey}`, {
            paramsUrl: getParamsUrl(),
            userEmail: data.email,
            accountUrl: new Site({ sld: SLD.ACCOUNT }).href,
        })
        Toast({
            message,
            type: 'error',
            duration: 3000,
        });
    }

    /**
   * handle a successful event
   * @param response Google 身份验证凭据
   * @param getTenant 是否需要获取租户列表
   * @returns
   */
    async function handleOnSuccess(
        response: CredentialResponse,
        getTenant = true
    ) {
        const { credential } = response;
        if (!credential) return;
        const { getTenantList } = useTenant();
        try {
            let shouldExecuteNext = true;
            if (getTenant) {
                shouldExecuteNext = await getTenantList(response);
            }
            /** 无租户列表或有默认租户id，则直接登录，否则先选租户 */
            if (!shouldExecuteNext) return;
            await postLoginSocialIndividual({ credential }, channels.value);
            refreshPage();
        } catch (err) {
            const code = getErrorCode(err);
            const tokenStr = credential.split('.')[1];
            const tokenData = JSON.parse(decode(tokenStr));
            const email = tokenData.email;
            if (code === ERROR_CODE.GOOGLE_NEED_PASSWORD_CONFIRM) {
                const password = await checkPassword({ email: tokenData.email });
                if (!password) return;
                try {
                    await submitPassword({ password, credential });
                    refreshPage();
                } catch (err) {
                    const code = getErrorCode(err);
                    alertErrorByCode({ code, email });
                }
                return;
            }
            alertErrorByCode({ code, email });
        }
    }

    // handle an error event
    function handleOnError() {
        console.log('Login failed');
    }

    return {
        handleOnSuccess,
        handleOnError,
    };
}
